import React, { useEffect, useMemo, useState } from 'react';
import {
  Container,
} from '@mui/material';
import { MainContentArea, MainContentAreaChildGrid } from './styled';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useCurrentUserInfo from '../../hooks/useCurrentUserInfo';
import { chefEditRecipe } from '../../redux/actions/recipeActions';
import { CLEAR_RECIPE_UPLOAD_STATE } from '../../redux/reducerConsts/chefAdminConsts';
import Header from './Header';
import ViewMode from './ViewMode';
import EditMode from './EditMode';

const EditRecipeDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const userInfo = useCurrentUserInfo();

  const userId = userInfo?.user_id;
  const chefAdminRecipes = useSelector((state) => state.chefAdminRecipeData.chefAdminRecipes);

  const [isEditing, setIsEditing] = useState(false);

  const recipe = useMemo(() => 
    chefAdminRecipes.find(recipe => recipe?._id === params.id) || null
  , [chefAdminRecipes, params.id]);

  const availableTags = ['Vegetarian', 'Vegan', 'Gluten-Free', 'Quick', 'Dessert', 'Main Course'];

  const handleSave = ({recipeData, recipeContent}) => {

    dispatch(
      chefEditRecipe({
        userId: userId,
        recipeId: recipeData?._id,
        updatedRecipe: {
          ...recipeData,
          recipeContent: recipeContent
        }
      })
    );

    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  // Post Upload Redirected Here, Clearing Uploading State After
  useEffect(() => {
    dispatch({ type: CLEAR_RECIPE_UPLOAD_STATE });
  }, []);

  return (
    <MainContentArea elevation={0}>
      <MainContentAreaChildGrid container>
        <Header 
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          onSave={handleSave}
          onNavigateBack={() => navigate(-1)}
        />

        {/* Main Content */}
        <Container maxWidth="md" sx={{ py: 4 }}>
          {
            isEditing ?

            <EditMode
              onSave={handleSave}
              recipe={recipe}
              userId={userId}
              availableTags={availableTags}
              onCancel={handleCancel}
            /> 
            
            :

            <ViewMode recipe={recipe} />
          }
        </Container>
      </MainContentAreaChildGrid>
    </MainContentArea>
  );
};

export default EditRecipeDetails;